import { ErrorWrapper, ResponseWrapper } from '@/core/service/util'
import {RoomBaseApiService} from "@/core/service/room.baseapi.service";
import axios from "axios";

class RoomLmsService extends RoomBaseApiService {
    async getLmsUserList() {
        try {
            const response = await this.request().get(`/api/v3/lms/users?roomId=${ this.getRoomId() }`);
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async sendSMSToLmsUser(params) {
        try {
            const response = await this.request().post(`/api/v3/lms/users/sms`, { roomId: this.getRoomId(), ...params });

            if (response.status !== 200) {
                throw await response.json()
            }
        } catch (error) {
            throw error
        }
    }

    async sendSMSToAllLmsUser(params) {
        try {
            const response = await this.request().post(`/api/v3/lms/users/sms`, { roomId: this.getRoomId(), ...params });

            if (response.status !== 200) {
                throw await response.json()
            }
        } catch (error) {
            throw error
        }
    }
}

export const roomLmsService = new RoomLmsService()
